export default __webpack_public_path__ + "static/media/PFSquareSansProExtraBlack_35482.dfdb85f3.ttf";